export default __webpack_public_path__ + "static/media/new_statement3.5f251847.png";